var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PreviewAppendix',{attrs:{"dataContract":_vm.dataContract,"dataAppendix":_vm.dataAppendix,"dataConfig":_vm.dataConfig,"srcPDF":_vm.srcPDF,"canBack":""}}),_c('VueLoadingOverlay',{attrs:{"active":_vm.showLoading,"is-full-page":true},on:{"update:active":function($event){_vm.showLoading=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }